import {
  useJsonForms,
  withJsonFormsControlProps,
  JsonFormsDispatch,
} from "@jsonforms/react";
import {
  ControlProps,
  rankWith,
  UISchemaElement,
  Labeled,
  Internationalizable,
  isDescriptionHidden,
  isDateControl,
} from "@jsonforms/core";
import showRule from "../../RuleEvaluate";
import { useState, useEffect } from "react";
import CustomBaseRenderers from "./CustomBaseRenderer";

interface CustomHorizontalProps
  extends UISchemaElement,
    Labeled,
    Internationalizable {
  type: "CustomHorizontal";
  elements: UISchemaElement[];
  className?: string;
  title: string;
  titleClassName?: string;
  outerContainerClass?: string;
  additionalData?: any;
}

export const CustomHorizontal = ({
  data,
  handleChange,
  path,
  schema,
  visible,
  uischema,
  enabled,
}: ControlProps) => {
  const [selectedOption, setSelectedOption] = useState("");
  const uischemaFile = uischema as unknown as CustomHorizontalProps;
  const ctx = useJsonForms();
  const materialCells = ctx?.cells;
  const customRenderers = CustomBaseRenderers;
  const {
    className,
    titleClassName,
    title,
    outerContainerClass,
    additionalData,
  } = uischemaFile;

  let show =
    uischema?.options?.show === undefined ? true : uischema?.options?.show;
  if (additionalData?.customRule) {
    show = showRule(additionalData, ctx);
  }
  visible = show && visible;
  const func = (ele: any) => {
    let testData = ele;
    if (!testData.options) {
      testData.options = {};
    } else {
      let optionsData = {
        ...testData?.options,
        show: show,
      };

      testData.options = optionsData;
    }

    return testData;
  };

  return (
    <div className={`${show ? outerContainerClass : "h-[0px] mt-0  mb-0"}`}>
      <p className={`${show ? titleClassName : "hidden"} `}>{title}</p>
      <div
        className={`${
          show
            ? "lg:flex space-y-8 lg:space-y-0 lg:space-x-5 mid:space-x-10 "
            : ""
        }  ${show ? className : ""}`}
      >
        {uischemaFile?.elements.map((ele, index) => (
          <JsonFormsDispatch
            key={`element-${index}`}
            uischema={func(ele)}
            renderers={customRenderers}
            cells={materialCells}
          />
        ))}
      </div>
    </div>
  );
};

export default withJsonFormsControlProps(CustomHorizontal);
